﻿const SELECTORS = {
    container: ".acr-tabs-container",
    navTabs: ".viwo-nav-tabs",
    navLink: ".nav-link",
    tabContent: ".acr-tab-content",
    tabPane: ".acr-tab-pane"
};

function injectDynamicElements() {
    document.querySelectorAll(".tabs-style-7").forEach((container) => {
        const navTabs = container.querySelector(SELECTORS.navTabs);

        if (navTabs && !navTabs.querySelector(".floating-circle")) {
            const circle = document.createElement("div");
            circle.classList.add("floating-circle");
            navTabs.appendChild(circle);
        }
    });
}

function updateIndicators(container) {
    const navTabs = container.querySelector(SELECTORS.navTabs);
    const activeLink = container.querySelector(`${SELECTORS.navLink}.active`);

    if (!navTabs || !activeLink) return;

    const linkRect = activeLink.getBoundingClientRect();
    const navRect = navTabs.getBoundingClientRect();

    if (
        container.classList.contains("tabs-ios-pills") ||
        container.classList.contains("tabs-style-5")
    ) {
        const width = linkRect.width;
        const left = linkRect.left - navRect.left;

        navTabs.style.setProperty("--pill-width", `${width}px`);
        navTabs.style.setProperty("--pill-left", `${left}px`);
        navTabs.style.setProperty("--indicator-width", `${width / 2}px`);
        navTabs.style.setProperty("--indicator-left", `${left + (width / 4)}px`);
        navTabs.style.setProperty("--pill-opacity", "1");
    }

    if (container.classList.contains("tabs-style-7")) {
        const circleRadius = 28;
        const circleCenter = (linkRect.left - navRect.left) + (linkRect.width / 2) - circleRadius;

        navTabs.style.setProperty("--circle-left", `${circleCenter}px`);

        const floatingCircle = container.querySelector(".floating-circle");
        const activeIcon = activeLink.querySelector("i");

        if (floatingCircle && activeIcon) {
            floatingCircle.innerHTML = `<i class="${activeIcon.className}"></i>`;
        }
    }
}

function triggerRipple(e, btn) {
    const circle = document.createElement("span");
    const d = Math.max(btn.clientWidth, btn.clientHeight);
    const rect = btn.getBoundingClientRect();

    circle.style.width = circle.style.height = `${d}px`;
    circle.style.left = `${e.clientX - rect.left - d / 2}px`;
    circle.style.top = `${e.clientY - rect.top - d / 2}px`;
    circle.classList.add("viwo-ripple");

    const ripple = btn.getElementsByClassName("viwo-ripple")[0];
    if (ripple) ripple.remove();

    btn.appendChild(circle);
}

function initAnimatedContainers() {
    const animatedContainers = document.querySelectorAll(
        ".tabs-ios-pills, .tabs-style-5, .tabs-style-7"
    );

    animatedContainers.forEach((container) => {
        window.setTimeout(() => updateIndicators(container), 50);
    });
}

function handleTabClick(e) {
    const tabBtn = e.target.closest(`${SELECTORS.navTabs} ${SELECTORS.navLink}`);
    if (!tabBtn) return;

    e.preventDefault();

    const currentContainer = tabBtn.closest(SELECTORS.container);
    if (!currentContainer) return;

    const headerLinks = currentContainer.querySelectorAll(SELECTORS.navLink);
    headerLinks.forEach((btn) => btn.classList.remove("active"));
    tabBtn.classList.add("active");

    const targetId = tabBtn.getAttribute("data-viwo-target");
    if (!targetId) return;

    const targetPane = document.querySelector(targetId);
    if (targetPane) {
        const contentWrapper = targetPane.closest(SELECTORS.tabContent);

        if (contentWrapper) {
            const siblingPanes = contentWrapper.querySelectorAll(SELECTORS.tabPane);
            siblingPanes.forEach((pane) => pane.classList.remove("active"));
            targetPane.classList.add("active");
        }
    }

    updateIndicators(currentContainer);

    if (currentContainer.classList.contains("tabs-android")) {
        triggerRipple(e, tabBtn);
    }
}

function handleResize() {
    document
        .querySelectorAll(".tabs-ios-pills, .tabs-style-5, .tabs-style-7")
        .forEach((container) => updateIndicators(container));
}

export function initTabs() {
    const containers = document.querySelectorAll(SELECTORS.container);
    if (!containers.length) return;

    injectDynamicElements();
    initAnimatedContainers();

    document.addEventListener("click", handleTabClick);
    window.addEventListener("resize", handleResize);
}